import React from 'react';
import { Snackbar, Grid, Icon } from 'e100-react-components';
import { useOperations as useApplicationOperations } from 'store/features/application';

import useStyles from './useStyles';
import Actions from './Actions';
import useMessage from './hooks/useMessage';
import { INotice } from 'store/features/application/types/notice';

const Snack = (props: INotice) => {
  const { id, type, hideActions, icon } = props;
  const { resetNotice } = useApplicationOperations();
  const classes = useStyles();

  const message = useMessage(props);

  const autoHideDuration = (type === 'error' ? 10 : 2) * 1000; //seconds

  const hideNotice = () => {
    resetNotice({ id });
  };

  if (!message) return null;
  return (
    <Snackbar
      open={true}
      onClose={() => {
        hideNotice();
      }}
      classes={{
        root: classes.root,
      }}
      TransitionProps={{
        onExited: hideNotice,
      }}
      message={
        <Grid
          container
          alignItems='center'
          classes={{ root: classes.container }}
        >
          {icon && (
            <Grid item>
              <Icon kind={icon.kind} style={{ color: icon.iconColor }} />
            </Grid>
          )}
          <Grid item>{message}</Grid>
          {!hideActions && (
            <Grid item classes={{ root: classes.actions }}>
              <Actions onHide={hideNotice} notice={props} />
            </Grid>
          )}
        </Grid>
      }
      autoHideDuration={autoHideDuration}
    />
  );
};

export default Snack;
